import React, { useRef } from "react";
import ReactDOMServer from "react-dom/server";

import emailjs from "@emailjs/browser";
import PixellWelcomeEmail from "./PixellWelcomeEmail";

const EmailForClient = () => {
  const sendEmail = async () => {
    try {
      const htmlString = ReactDOMServer.renderToStaticMarkup(
        <PixellWelcomeEmail />
      );
      const templateParams = {
        name: "Pixell",
        title: "Welcome to pixell",
        from_email: "admin@pixell.in",
        // user_email: "ankit.pandey@duroply.com", // Email the user entered
        // user_email: "karan.ahuja@duroply.com", // Email the user entered
        user_email: "manishnaaagar@gmail.com", // Email the user entered

        message: htmlString, // Your message or any content
      };

      const result = await emailjs.send(
        // "service_dmmvym2",
        "service_64b322r",
        "template_rva3ow9",
        templateParams,
        "utKsV9_JzxvuWaRBi"
      );

      alert("Email sent successfully!");
      console.log(result.text);
    } catch (error) {
      alert("Failed to send email.");
      console.error(error); // full error object
    }
  };

  return (
    <div>
      {/* Render the email content */}

      {/* Button to send email */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={sendEmail}
          style={{
            padding: "12px 30px",
            backgroundColor: "#9B3FFD",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Send Welcome Email
        </button>
      </div>
    </div>
  );
};

export default EmailForClient;
